module.exports = __webpack_public_path__ + "static/media/animate-11.81e9bcbe.mp4";